import { IArticleSummaryProps } from './interfaces';
import { RichText } from 'prismic-reactjs';
import React from 'react';
import ArticleHeader from './ArticleHeader';
import ArticleLinkImage from './ArticleLinkImage';
import { Routes } from '../../../models/enums/routes';
import {
  ArticleSummaryContent,
  ArticleSummaryReadMore,
  ArticleSummaryWrapper,
} from './styles';

export const ArticleSummary = ({
  article,
  contentPage,
}: IArticleSummaryProps): JSX.Element => {
  return (
    <ArticleSummaryWrapper>
      <ArticleHeader
        title={article.title}
        className={'article-summary'}
        seo_url={article.seo_url}
        author={article.author}
        publishDate={article._meta.firstPublicationDate}
        tags={article._meta.tags}
        authorImage={article.author_image}
        titleIsLink
      />
      <ArticleLinkImage
        className="article-summary"
        image={article.article_image}
        url={RichText.asText(article.seo_url)}
        title={RichText.asText(article.title)}
      />
      <ArticleSummaryContent>
        <p>{article.content[0].text}</p>
        <ArticleSummaryReadMore
          href={`${Routes.InsightsArticleId}${RichText.asText(
            article.seo_url
          )}`}
        >
          {RichText.asText(contentPage.read_more_button || '')}
        </ArticleSummaryReadMore>
      </ArticleSummaryContent>
    </ArticleSummaryWrapper>
  );
};
